import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AccountDetails = class AccountDetails extends Vue {
    get infos() {
        return [
            {
                label: 'Contact Name',
                value: `${this.fullName}`,
            },
            {
                label: 'Phone Number',
                value: this.mobileNumber,
            },
            {
                label: 'Billing Contact Email',
                value: this.email,
            },
            {
                label: 'Payment Currency',
                value: this.currency,
            },
        ];
    }
};
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "fullName", void 0);
__decorate([
    Prop({ type: String, required: false })
], AccountDetails.prototype, "accountNumber", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "paymentMethod", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "address", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "city", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "country", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "stateProvinceRegion", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "zipPostalCode", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "mobileNumber", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "email", void 0);
__decorate([
    Prop({ type: String, required: true })
], AccountDetails.prototype, "currency", void 0);
AccountDetails = __decorate([
    Component
], AccountDetails);
export default AccountDetails;
